/**
   * @ngdoc directive
   * @name adjust.apps.directive:rightSidebarBreadcrumbs
   * @scope
   * @restrict E
   *
   * @description
   * Generates tracker breadcrumbs
   *
   */
function rightSidebarBreadcrumbs() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {},
    template: require('./right-sidebar-breadcrumbs.html'),
    controller: 'RightSidebarBreadcrumbsController',
    controllerAs: 'vm',
    bindToController: {
    }
  };
}

/**
   * @ngdoc controller
   * @name adjust.controller:RightSidebarBreadcrumbsController
   *
   * @description
   * All the functionality of the {@link adjust.apps.directive:rightSidebarBreadcrumbs rightSidebarBreadcrumbs} directive
   *
   */
function RightSidebarBreadcrumbsController($scope, $state, $timeout, configuration) {
  'ngInject';
  var _baseWidth = configuration.isBeta ? 42 : 35;
  var _transitionTime = 300;

  var vm = this;

  vm.steps = [];
  vm.containerOffset = 0;

  vm.goTo = goTo;

  $scope.$on('rightSidebarBreadcrumbs:set', _handleSet);

  /**
   * @ngdoc method
   * @name goTo
   * @methodOf adjust.controller:RightSidebarBreadcrumbsController
   *
   * @description
   * Transition to a step
   *
   * @param {Object} step
   */
  function goTo(step) {

    if (typeof step.callback === 'function') {
      return step.callback.call(this);
    }

    $state.go(step.sref, step.params);

    if (step.isFirst) {
      $scope.$emit('rightSidebar:reset');
      _handleSet(null, []);
    }

  }

  /**
   * @ngdoc method
   * @name _handleSet
   * @methodOf adjust.controller:RightSidebarBreadcrumbsController
   *
   * @description
   * Handles the change event emitted from the outside world
   *
   * @param {Object} e state change event object
   * @param {Array} newSteps
   * @private
   */
  function _handleSet(e, newSteps) {

    if (vm.steps.length < newSteps.length) {
      _drillDown(newSteps);
    } else {
      _drillUp(newSteps);
    }

  }

  /**
   * @ngdoc method
   * @name _drillDown
   * @methodOf adjust.controller:RightSidebarBreadcrumbsController
   *
   * @description
   * Drills down deeper by adding new elements to the hierarchy and changing the offset
   *
   * @param {Array} newSteps
   * @private
   */
  function _drillDown(newSteps) {

    _setSteps(vm.steps.concat(newSteps.slice(vm.steps.length)));
    _setWidth(vm.steps.length);

  }

  /**
   * @ngdoc method
   * @name _drillDown
   * @methodOf adjust.controller:RightSidebarBreadcrumbsController
   *
   * @description
   * Drills up by changing the offset and then removing elements behind scenes
   *
   * @param {Array} newSteps
   * @private
   */
  function _drillUp(newSteps) {

    _setWidth(newSteps.length);

    $timeout(function() {
      _setSteps(newSteps);
    }, _transitionTime);

  }

  /**
   * @ngdoc method
   * @name _setSteps
   * @methodOf adjust.controller:RightSidebarBreadcrumbsController
   *
   * @description
   * Replaces the stored list of steps with a new list
   *
   * @param {Array} newSteps
   * @private
   */
  function _setSteps(newSteps) {

    if (newSteps[0]) {
      newSteps[0].isFirst = true;
    }

    vm.steps = newSteps;

  }

  /**
   * @ngdoc method
   * @name _setWidth
   * @methodOf adjust.controller:RightSidebarBreadcrumbsController
   *
   * @description
   * Updates the offset based on the amount of visible elements
   *
   * @param {Integer} totalVisible
   * @private
   */
  function _setWidth(totalVisible) {

    $timeout(function() {
      vm.containerOffset = (totalVisible * _baseWidth) * -1;
    });

  }
}


export { RightSidebarBreadcrumbsController, rightSidebarBreadcrumbs };
